<h5>Template name:</h5>
<input type="text" class="template-name input-block-level">

<h5>{{t "common.description"}}</h5>
<textarea class="template-description input-block-level"></textarea>

<button class="button positive template-save-button input-block-level">{{t "common.save"}}</button>
